import React from "react";
import { Box, Grid, FlexiPagination } from "@flexisaf/flexibull2";
import Theme from "../../../theme";
import { Loader } from "@flexisaf/flexibull2/build/loader";
import { EmptyState } from "@flexisaf/flexibull2/build/emptystates";
import { setCurrentfeedback } from "../../../redux/feedback/reducer";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ResolvedFeedbackList from "../../../components/feedback/ResolvedFeedbackList";

const Resolved = ({
  feedbacks,
  isLoading,
  pageOptions,
  totalElements,
  limit,
  setPage,
  page,
  setLimit,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <div>
      {isLoading ? (
        <Grid>
          <Box
            style={{
              height: "70vh",
              width: "70vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader color={Theme.PrimaryColor} />
          </Box>
        </Grid>
      ) : feedbacks?.items?.length > 0 ? (
        <>
          <Grid default="1fr 1fr 1fr 1fr" gap="20px">
            {feedbacks?.items?.map((feedback) => {
              return (
                <ResolvedFeedbackList
                  feedback={feedback}
                  handleRedirect={() => {
                    dispatch(setCurrentfeedback(feedback));
                    navigate(`/feedback`);
                  }}
                />
              );
            })}
          </Grid>
          <FlexiPagination
            pageCounts={pageOptions}
            itemsDisplayed
            total={totalElements}
            pageSize={limit}
            onChange={(page) => {
              setPage(page);
            }}
            changePageSize={({ value }) => {
              setPage(1);
              setLimit(value);
            }}
            current={page}
          />
        </>
      ) : (
        <Box align="center">
          <EmptyState
            type="documents"
            title="Feedback not found."
            // info="Please create paper to proceed"
          />
        </Box>
      )}
    </div>
  );
};

export default Resolved;
